import Mutations from '../../odata/mutations';

export default { ...new Mutations('interviewQuestion'), ...new Mutations('interviewQuestions') };
